import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { SiteHeader } from '@/components/site-header'
import { SiteFooter } from '@/components/site-footer'
import { PageHeader } from '@/components/page-header'
import { ProfileSettings } from '@/components/settings/profile-settings'
import { AppearanceSettings } from '@/components/settings/appearance-settings'
import { SecuritySettings } from '@/components/settings/security-settings'

export function SettingsPage() {
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <PageHeader title="Settings" description="Manage your account settings and preferences." />
        <div className="container px-4 md:px-6 py-12 max-w-4xl mx-auto">
          <Tabs defaultValue="profile" className="max-w-4xl mx-auto">
            <div className="flex flex-col md:flex-row gap-6">
              <div className="md:w-64 flex-shrink-0">
                <TabsList className="flex flex-col h-auto p-0 bg-transparent space-y-1">
                  <TabsTrigger
                    value="profile"
                    className="justify-start px-4 py-2 h-10 font-normal data-[state=active]:font-medium w-full"
                  >
                    Profile
                  </TabsTrigger>
                  <TabsTrigger
                    value="appearance"
                    className="justify-start px-4 py-2 h-10 font-normal data-[state=active]:font-medium w-full"
                  >
                    Appearance
                  </TabsTrigger>
                  <TabsTrigger
                    value="security"
                    className="justify-start px-4 py-2 h-10 font-normal data-[state=active]:font-medium w-full"
                  >
                    Security
                  </TabsTrigger>
                </TabsList>
              </div>
              <div className="flex-1">
                <TabsContent value="profile" className="mt-0">
                  <ProfileSettings />
                </TabsContent>
                <TabsContent value="appearance" className="mt-0">
                  <AppearanceSettings />
                </TabsContent>
                <TabsContent value="security" className="mt-0">
                  <SecuritySettings />
                </TabsContent>
              </div>
            </div>
          </Tabs>
        </div>
      </main>
      <SiteFooter />
    </div>
  )
}
